import type { ProductVariant, ProductVariantAvailability } from '~~/types/commercetools';

export const getProductAvailability = (product: ProductVariant): Maybe<ProductVariantAvailability> =>
  product.availability?.noChannel;

export const getProductQuantity = (product: ProductVariant): number =>
  getProductAvailability(product)?.availableQuantity;

export const getProductIsOnStock = (product: ProductVariant): boolean | undefined =>
  getProductAvailability(product)?.isOnStock;
